import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from '../Tx';
import { useState } from 'react';
import { api } from '../../maps/data.js';
import { useEffect } from 'react';
import SensorStatus from "../SensorStatus";
import useZibi from "../../zibi/UseZibi";

export default function InstallerAddSensorsToEdgeDialog(props) {
    let { onClose, type, edgeId, types } = props;
    const [sensors, s_sensors] = useState([]);
    const [selected_sensors, s_selected_sensors] = useState([]);

    const [sensorStatuses] = useZibi('sensorStatuses');

    const add = async () => {

        await api({
            type: 'installerAddSensorsToEdge',
            data: {
                edgeId, 
                sensorIds: selected_sensors
            }
        });

        onClose();
    }

    const getSensors = async () => {
        const data = {
            unrelated: true
        };
        if (type) {
            data.type = type;
        }

        if (types?.length) {
            delete data.type;
            data.types = types;
        }
        const res = await api({
            type: 'getSensors',
            data: data
        });
        s_sensors(res);
    }

    useEffect(() => {
        getSensors();
    }, []);

    return (
        <Dialog
            open={true}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth={true}>
            <DialogTitle id="alert-dialog-title">
                <Tx>{`sensor.${type}.addToEdge`}</Tx>
            </DialogTitle>
            <DialogContent style={{ paddingTop: 5 }}>

                {
                    sensors.map(sensor => {
                        const sensorStatusData = sensorStatuses[sensor._id];
                        const status = sensorStatusData?.status;
                        const statusUpdateAt = sensorStatusData?.statusUpdateAt;
                        return(
                            <Button
                                style={{ minWidth: 150, margin: 3 }}
                                variant={selected_sensors.includes(sensor._id) ? 'contained' : 'outlined'}
                                key={sensor._id}
                                onClick={() => {
                                    if (selected_sensors.includes(sensor._id)) {
                                        let s = selected_sensors.concat();
                                        s.splice(s.indexOf(sensor._id), 1);
                                        s_selected_sensors(s)
                                    } else {
                                        s_selected_sensors(selected_sensors.concat(sensor._id))
                                    }
                                }}>
                                <SensorStatus status={status} statusUpdateAt={statusUpdateAt}/>
                                {sensor.boardId}
                            </Button>
                        )
                    })
                }

            </DialogContent>

            <DialogActions>

                <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                <Button autoFocus type='submit' disabled={selected_sensors.length === 0} onClick={add}>
                    <Tx>g.add</Tx>
                </Button>

            </DialogActions>
        </Dialog>)
}